import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { get } from 'lodash';
import withLoader from '../app/withLoader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox } from 'redux-form-material-ui';

const enhance = compose(
  withLoader,
  withHandlers({
    onSubmit: ({ flagDialog, setFlagDialog, toggleLoader, addAttribute }) => async values => {
      toggleLoader();
      await addAttribute(get(flagDialog, 'id'), values.flags ? 1 : 0);
      setFlagDialog({ open: false });
      toggleLoader(false);
    }
  }),
  reduxForm({ form: 'flagsForm' })
);

export default enhance(({ flagDialog, setFlagDialog, fullScreen, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Dialog
      fullScreen={fullScreen}
      open={flagDialog.open}
      onClose={() => setFlagDialog({ open: false })}
      aria-labelledby="responsive-dialog-title"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle id="responsive-dialog-title">Přidání atributu</DialogTitle>
      <DialogContent>
        <Grid container={true} spacing={16}>
          <Grid item={true} xs={6}>
            <FormControlLabel
              control={<Field name="flags" component={Checkbox} />}
              label="Zobrazit v rezervacích"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button type="submit" color="primary" variant="contained" onClick={handleSubmit} autoFocus>
          Uložit
        </Button>
        <Button
          onClick={() => setFlagDialog({ open: false })}
          color="secondary"
          variant="contained"
        >
          Zrušit
        </Button>
      </DialogActions>
    </Dialog>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/categories/flagDialog.js